import React, { useContext } from 'react';
import Pagination from '../Usables/Pagination';
import NoRecords from '../Usables/NoRecords';
import RefreshButton from '../Usables/RefreshButton';
import InputField from '../Usables/InputField';
import Dropdown from '../Usables/Dropdown';
import BasicButton, { DeleteButton } from '../Usables/Buttons';
import Loader from '../Usables/Loader';
import { formatDate } from '../Constants/constant';
import CloseModal from '../Usables/CloseModal';
import { useParams } from 'react-router-dom';
import { AppContext } from '../ContextApi/ContextApi';

const SourcedCandidateList = React.memo(({ filter, rows, pagination, status, isUpdate, loading, loadingFilter, loadingDelete,
    onChange, onClose, onRefresh, onFilter, onEdit, onStatusChange, onClear, onDelete, onExport, onLimit, onPrev, onNext }) => {
    const { index } = useParams();
    const {user} = useContext(AppContext);
        const statusOptions = [
        {value: "Rejected", label: "Rejected"},
        {value: "Confirmation Pending", label: "Confirmation Pending"},
        {value: "Screened", label: "Screened"},
    ];
    const relevantOptions = [
        {value: "Yes", label: "Yes"},
        {value: "No", label: "No"},
    ];

    const handleCheckStatus = (value)=> {
        const statusList = [
        {name: "Rejected", className: "rounded-lg text-red-500 redBox"},
        // {name: "Confirmation Pending", className: "rounded-lg text-amber-500 bg-amber-100"},
        {name: "Screened", className: "rounded-lg text-blue-500 bg-blue-100"},
        {name: "Sent To Client", className: "rounded-lg text-green-500 bg-green-100"},
    ];
        return statusList.find(status => status?.name === value) || false;
    };

    return (
        <div className=' w-full h-screen  fixed left-0 top-0 z-20 flex items-center justify-center blurBack'>
                <div className=' relative h-[95vh] w-[95%]  lightBabyGreen rounded-2xl mx-10 px-2 py-4   '>
                    <div className=' absolute bottom-3 right-4'>
                        {/* RefreshButton => used for refresh table data */}
                        <RefreshButton onClick={onRefresh} position='fixed' />
                    </div>
                    <CloseModal disabled={loading} onClick={onClose} />
                    <div className='h-full w-full  rounded-2xl overflow-y-scroll noScrollbar px-8'>
                        {/* filter */}
                        <div className=' grid lg:grid-cols-5 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 items-center gap-3 grayBlurShadow bg-white p-3 mb-5 rounded-xl'>
                            <InputField  id="candidate" name="candidate" type="text" label="Candidate:"
                            placeholder="Enter Candidate"
                            disabled={loading === '1'}
                            value={filter?.candidate}
                            onChange={onChange}
                            />
                            <InputField  id="company" name="company" type="text" label="Company:"
                            placeholder="Enter Company"
                            disabled={loading === '1'}
                            value={filter?.company}
                            onChange={onChange}
                            />
                            <InputField  id="position" name="position" type="text" label="Position:"
                            placeholder="Enter Position"
                            disabled={loading === '1'}
                            value={filter?.position}
                            onChange={onChange}
                            />
                            <InputField  id="location" name="location" type="text" label="Location:"
                            placeholder="Enter Location"
                            disabled={loading === '1'}
                            value={filter?.location}
                            onChange={onChange}
                            />
                            <Dropdown id="relevant" name="relevant" label="Relevant:"
                            onChange={onChange}
                            className=" rounded border border-gray-300 w-full text-[0.8rem]"
                            placeholder={`Select`}
                            value={filter?.relevant}
                            options={relevantOptions}
                            />
                            <Dropdown id="status" name="status" label="Sourcing Status:"
                            onChange={onChange}
                            className=" rounded border border-gray-300 w-full text-[0.8rem]"
                            placeholder={`Select Status`}
                            value={filter?.status}
                            options={statusOptions}
                            />
                            <div className="flex gap-3 col-span-1">
                                <div className=" flex flex-col">
                                    <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">Apply Filter</label>
                                    <BasicButton onClick={onFilter} buttonName='Apply Filter' className='darkPurple text-nowrap' shadow={true}
                                    disabled={loading || loadingFilter || (!filter?.candidate && !filter?.company && !filter?.position && !filter?.location && !filter?.relevant && !filter?.status)} 
                                    loading={loadingFilter === "1"} loadingMessage="Loading" rounded="lg" textAlign="center" fontWeight="bold" onHover="hoverGreen" />
                                </div>
                                <div className=" flex flex-col">
                                    <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">Clear Filter</label>
                                    <BasicButton onClick={onClear} buttonName='Clear Filter' className="bg-red-600 text-nowrap" shadow={true}
                                    disabled={loading || loadingFilter || (!filter?.candidate && !filter?.company && !filter?.position && !filter?.location && !filter?.relevant && !filter?.status)} 
                                    loading={loadingFilter === "2"} loadingMessage="Loading" rounded="lg" textAlign="center" fontWeight="bold" onHover="hover:bg-red-900" />
                                </div>
                                <div className=" flex flex-col">
                                    <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">Excel Export</label>
                                    <BasicButton onClick={onExport} buttonName='Excel' className="bg-green-800 text-nowrap" shadow={true}
                                    disabled={loading || loadingFilter || rows?.length === 0} 
                                    loading={loadingFilter === "4"} loadingMessage="Loading" rounded="lg" textAlign="center" fontWeight="bold" onHover="hover:bg-green-950" />
                                </div>
                            </div>
                        </div>
                        {
                            loading === "2" ?
                            <Loader/> :
                            Array.isArray(rows) && rows?.length >= 1 ?
                            <div className=' bg-white px-3 pt-5 rounded-2xl'>
                                <div className=' overflow-auto tableBody  h-[79vh]'>
                                    <table className=' navAnimation rounded-2xl baseWidth p-5 text-left'>
                                        <thead className='text-lg tableHead'>
                                            <tr className=' bg-gray-200'>
                                                <th className='whitespace-nowrap text-center'>Sourcing Date</th>
                                                <th>Candidate</th>
                                                <th className='whitespace-nowrap'>Position</th>
                                                <th className='whitespace-nowrap'>Position CTC</th>
                                                <th className='whitespace-nowrap'>CV Sourced From</th>
                                                <th>Relevant</th>
                                                <th className='whitespace-nowrap text-center'>Status</th>
                                                {user[index]?.delete_access && <th className='whitespace-nowrap text-center'>Action</th>}
                                            </tr>
                                        </thead>
                                        <tbody className='tableBody '>
                                            {
                                                Array.isArray(rows) && rows?.map((val, idx) => {
                                                    return (
                                                        <tr key={val?.id} id={val?.id} className=' backWhite font-semibold text-sm'>
                                                            <td className=' whitespace-nowrap text-left'>
                                                                <span className='line-clamp-1 text-ellipsis'>{val?.sourcing_date ? formatDate(val?.sourcing_date) : "--"}</span>
                                                                {localStorage.getItem("role") === "Recruiter" || localStorage.getItem("role") === "Team Lead" ? null : 
                                                                (<span className={`line-clamp-1 text-ellipsis ${val?.sourcing_status === 'Confirmation Pending' ? `text-yellow-600`: val?.sourcing_status === 'Rejected' ? `text-red-700` : `text-green-600`}`}
                                                                >{val?.User?.name}</span>)}
                                                            </td>
                                                            <td className=' whitespace-nowrap'>
                                                                <span className={`line-clamp-1 text-ellipsis text-blue-900 ${val?.candidate && (user[index]?.view_access || user[index]?.edit_access) && "hover:text-blue-700 hover:underline transition-all duration-150 ease-in-out cursor-pointer"}`} onClick={()=> { if (val?.candidate && (user[index]?.view_access || user[index]?.edit_access)) onEdit(val)}}>{val?.candidate || "--"}</span>
                                                                <span className='text-sm line-clamp-1 text-ellipsis text-gray-400'>{val?.candidate_email ? val?.candidate_email : "NA"}</span>
                                                            </td>
                                                            <td className=' whitespace-nowrap'>
                                                                <span className='line-clamp-1 text-ellipsis' >{val?.Position?.position}</span>
                                                                <span className='text-sm line-clamp-1 text-ellipsis text-gray-400'>{val?.Position?.Company.company_name}</span>
                                                            </td>
                                                            <td>
                                                                <div className=' flex flex-col'>
                                                                    <span><span className=' text-green-500'>{val?.current_currency_code}</span> {val?.Position?.min_ctc?.padStart(2,0) || "00"} LPA</span> 
                                                                    <span><span className=' text-green-500'>{val?.current_currency_code}</span> {val?.Position?.max_ctc?.padStart(2,0) || "00"} LPA</span>
                                                                </div>
                                                            </td>
                                                            <td>{val?.cv_sourced_from}</td>
                                                            <td className='whitespace-nowrap text-center'>
                                                                <div className={` whitespace-nowrap py-2 px-1 border border-gray-300  ${val?.relevant === "Yes" ? " text-green-500 greenBox" : "text-red-600 redBox"}`} >
                                                                    {val?.relevant}</div>
                                                            </td>
                                                            <td className='whitespace-nowrap text-center'>
                                                                {handleCheckStatus(val?.sourcing_status) ? 
                                                                <h3 className={`line-clamp-1 text-ellipsis w-full text-center text-nowrap outline-none border border-gray-300 py-2.5 px-1 ${handleCheckStatus(val?.sourcing_status)?.className}`}>
                                                                    {handleCheckStatus(val?.sourcing_status)?.name}
                                                                </h3> :
                                                                    <Dropdown id="company_id" name="company_id"
                                                                    onChange={(e)=> onStatusChange(e,idx,val)}
                                                                    className=" rounded border border-gray-300 w-full text-[0.8rem]"
                                                                    placeholder={`Select`}
                                                                    value={status && isUpdate === val?.id ? status : val?.sourcing_status}
                                                                    options={statusOptions}
                                                                    disabled={!user[index]?.edit_access}
                                                                    />
                                                                }
                                                            </td>
                                                            {user[index]?.delete_access && <td className=' flex justify-center items-center'>
                                                                <DeleteButton data={val} onClick={(e) => onDelete(e)} tooltipName="Delete" disabled={val?.sourcing_status === "Sent To Client" || loadingDelete} />
                                                            </td>}
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table >
                                </div>
                                <Pagination onLimitChange={onLimit} onPrevChange={onPrev} onNextChange={onNext}
                                limit={pagination?.pagelimit} totalRecords={pagination?.totalRecords} allPages={pagination?.totalPages} page={pagination?.page}
                                disabledPrev={pagination?.page === 1} disabledNext={pagination?.page === pagination?.totalPages}
                                />
                            </div> :
                            <NoRecords/>
                        }
                    </div>
                </div>
            </div>
    );
})

export default SourcedCandidateList;
